module.exports = __webpack_public_path__ + "42cf4a6331d5606866a0599c7346c216.pdf";